export default __webpack_public_path__ + "images/bd04f0f1a6bf302204f792c85c5be237-pets.svg";